import { LOGIN_OR_JOIN_METHODS } from './constants';
import type { LoginOrJoinMethod, LoginOrJoinMethodShortcode } from './types';

export const getLoginOrJoinMethod = (method: string): LoginOrJoinMethod | null =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-condition
	(!!method && LOGIN_OR_JOIN_METHODS[method as LoginOrJoinMethodShortcode]) || null;
